import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import BOC from '../bankOrCredit';
import CONSTANT from '../../utils/constants';
import { PAYMODE } from '../../../../common/src/constant';
import { clientMessage } from '../../utils/common';

class PDC extends Component {
  constructor(props) {
    super(props);
    const locale = clientMessage(PAYMODE.POSTPAID.toLowerCase(), this.props.cache);
    this.state = {
      initializeObject: {
        type: 'INITIALIZE',
        messageObj: {
          label: locale.label,
          error: locale.error
        }
      }
    };
  }

  submit = () => {
    (typeof this.boc._component.submit === 'function' && this.boc._component.submit()) ||
      (typeof this.boc.submit === 'function' && this.boc.submit());
  };

  render({ option, onOptionSelect, isActive, offers, isPromoAvailable }, { initializeObject }) {
    return (
      <BOC
        {...{ option, isActive, onOptionSelect, offers, isPromoAvailable }}
        paymentMode={CONSTANT.POSTPAID}
        ref={r => (this.boc = r)}
        passcodeRequired={option.passcodeRequired}
        {...{ initializeObject }}
      />
    );
  }
}

export default connect('cache')(PDC);



// WEBPACK FOOTER //
// ./components/postpaid/index.js